/* global jQuery COMPONENTS */

COMPONENTS.ComponentPageIntro = (function ($) {
  function ComponentPageIntro () {
    this.$sliderElem = $('[data-ecs-components-control="intro-slider"]')

    const utility = new COMPONENTS.Utility()

    // Page intro always shows a single slide
    this.sliderVars = utility.getSliderVars(1)
  }

  ComponentPageIntro.prototype.init = function () {
    this.$sliderElem.slick(this.sliderVars)
  }

  return ComponentPageIntro
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.ComponentpageIntro = new COMPONENTS.ComponentPageIntro()
  COMPONENTS.ComponentpageIntro.init()
})
